/* Header URLS */

const FINANCIAL_BASE_URL = '/financial/';
const ORDERS_BASE_URL = '/volumes/';
const HELP_BASE_URL = '/help/';
const PRODUCTS_BASE_URL = '/products/';
const QUESTIONS_BASE_URL = '/questions/';
const SETTINGS_BASE_URL = '/settings/';
const ANALYTICS_BASE_URL = '/analytics/';

export const ONBOARDING_BASE_URL = '/onboarding';
export const OVERVIEW_BASE_URL = '/overview';

export const ANALYTICS_URL = ANALYTICS_BASE_URL;
export const FINANCIAL_URL = FINANCIAL_BASE_URL;
export const ORDERS_URL = `${ORDERS_BASE_URL}invoices`;
export const DASHBOARD_URL = '/dashboard/';
export const INTEGRATIONS_URL = '/integrations/';
export const LOGOUT_URL = '/logout/';
export const TERMS_OF_SERVICE_URL = '/terms-of-service/';
export const HELP_URL = HELP_BASE_URL;
export const QUESTIONS_URL = QUESTIONS_BASE_URL;
export const PRODUCTS_INDIVIDUAL_REGISTRATION_URL = `${PRODUCTS_BASE_URL}catalog/search/`;
export const PRODUCTS_MASS_REGISTRATION_URL = `${PRODUCTS_BASE_URL}import/`;
export const PRODUCTS_MY_PRODUCTS_URL = PRODUCTS_BASE_URL;
export const SETTINGS_URL = SETTINGS_BASE_URL;
export const SETTINGS_BANK_ACCOUNT_URL = `${ONBOARDING_BASE_URL}/bank-account/`;
export const STOCK_AND_PRICE_URL = '/stock/stock-and-price/';

/* Onboarding Router URLs */
export const ONBOARDING_FIRST_STEPS_PATH = `/first-steps/`;
export const ONBOARDING_FIRST_STEPS_URL = `${ONBOARDING_BASE_URL}/first-steps/`;
export const PERSONAL_INFORMATION_URL = `${ONBOARDING_BASE_URL}/personal-information/`;
export const ERROR_URL = `${ONBOARDING_BASE_URL}/error/`;

export const PERSONAL_INFORMATION_PATH = '/personal-information';
export const LOGISTIC_ADDRESS_PATH = `/logistic-address`;
export const COMPANY_INFORMATION_PATH = `/company-information`;
export const LIABLE_PARTNER_PATH = `/liable-partner`;
export const LOGISTIC_ADDRESS_URL = `${ONBOARDING_BASE_URL}${PERSONAL_INFORMATION_PATH}/logistic-address`;
export const COMPANY_INFORMATION_URL = `${ONBOARDING_BASE_URL}${PERSONAL_INFORMATION_PATH}/company-information`;
export const LIABLE_PARTNER_URL = `${ONBOARDING_BASE_URL}${PERSONAL_INFORMATION_PATH}/liable-partner`;

/* Subscription Router URLs */
export const SUBSCRIPTION_BASE_URL = '/subscription';
export const SUBSCRIPTION_PLAN_CHOICE_URL = `${SUBSCRIPTION_BASE_URL}/plan-choice/`;
export const ONBOARDING_PLAN_PRESENTATION_URL = `${ONBOARDING_BASE_URL}/plan-presentation/`;
export const SUBSCRIPTION_PLAN_CHOICE_URL_NEW = `${SUBSCRIPTION_BASE_URL}/plan-choice-new/`;
export const SUBSCRIPTION_PAYMENT_URL = `${SUBSCRIPTION_BASE_URL}/payment/`;

/* Setup Router URLs */
export const SETUP_BASE_URL = '/setup';
export const WELCOME_URL = `${SETUP_BASE_URL}/welcome`;
export const CATEGORIES_URL = `${SETUP_BASE_URL}/categories`;
export const REVENUES_URL = `${SETUP_BASE_URL}/revenues`;
export const UNQUALIFIED_URL = `${SETUP_BASE_URL}/unqualified`;
export const REQUISITES_URL = `${SETUP_BASE_URL}/requisites`;
export const CREATE_PASSWORD_URL = `${SETUP_BASE_URL}/create-password`;
